import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import RelatoriosService from '../../../service/relatorios';
import CongregacaoService from '../../../service/congregacoes';
import { FaSearch, FaUserClock, FaChartLine, FaUsers, FaExclamationTriangle, FaChartPie, FaChartBar, FaTimes } from 'react-icons/fa';
import Menu from '../../menu/Menu';
import Header from '../../cabecalho/Cabecalho';
import Rodape from '../../rodape/Rodape';
import Titulo from '../../titulo/Titulo';

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const ModalContent = styled.div`
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 90%;
    max-width: 600px;
    max-height: 80vh;
    overflow-y: auto;
    position: relative;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
`;

const CloseButton = styled.button`
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #666;
    &:hover { color: #333; }
`;

const ModalTitle = styled.h3`
    margin-top: 0;
    color: #333;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    margin-bottom: 15px;
`;

const UserList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
`;

const UserItem = styled.li`
    padding: 10px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:last-child { border-bottom: none; }
`;

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
`;

const MainContentWrapper = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  min-height: 0;
  margin-top: 85px;
  margin-bottom: 50px;

  @media (max-width: 767px) {
    margin-bottom: 0;
  }
`;

const Container = styled.div`
    flex: 1;
    overflow-y: auto;
    padding-left: 260px;
    padding-right: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
    background-color: #ffffff;
    font-family: 'Roboto', sans-serif;
    box-sizing: border-box;

    @media (min-width: 768px) and (max-width: 1200px) {
        padding-left: 80px;
    }

    @media (max-width: 767px) {
        padding-left: 20px;
    }
`;

const FiltrosContainer = styled.div`
    display: flex;
    gap: 24px;
    margin-bottom: 32px;
    @media (max-width: 768px) {
        flex-direction: column;
        gap: 16px;
    }
`;

const FiltroGroup = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 200px;
`;

const Label = styled.label`
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
    font-size: 16px;
`;

const SelectFilter = styled.select`
    padding: 8px 16px;
    border: 1px solid #008080;
    background-color: white;
    color: #008080;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    outline: none;
    transition: all 0.15s ease;

    &:hover:not(:disabled) {
        background: #008080;
        color: #fff;
    }

    &:focus {
        box-shadow: none;
    }
    
    option {
        background-color: #fff !important;
        color: #333 !important;
    }

    &:disabled {
        border-color: #ddd;
        background-color: #f5f5f5;
        color: #aaa;
        cursor: not-allowed;
    }
`;

const InputDateFilter = styled.input`
    padding: 8px 16px;
    border: 1px solid #008080;
    background-color: white;
    color: #008080;
    border-radius: 4px;
    font-size: 14px;
    outline: none;
    transition: all 0.15s ease;

    &:hover:not(:disabled) {
        background: #008080;
        color: #fff;
    }
    
    &::-webkit-calendar-picker-indicator {
        cursor: pointer;
        filter: invert(32%) sepia(96%) saturate(429%) hue-rotate(130deg) brightness(95%) contrast(101%);
    }
`;

const Button = styled.button`
    padding: 8px 16px;
    background-color: #008080;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    &:hover { background-color: #006666; }
`;

const StatsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
    margin-bottom: 30px;
`;

const StatCard = styled.div`
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    border: 1px solid #e0e0e0;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    border-left: 4px solid ${props => props.color || '#008080'};
    cursor: ${props => props.onClick ? 'pointer' : 'default'};
    transition: transform 0.2s;
    &:hover {
        transform: ${props => props.onClick ? 'scale(1.02)' : 'none'};
    }
`;

const StatValue = styled.div`
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin: 10px 0;
`;

const StatLabel = styled.div`
    color: #666;
    font-size: 14px;
`;

const Section = styled.div`
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    border: 1px solid #e0e0e0;
    margin-bottom: 30px;
`;

const SectionTitle = styled.h2`
    font-size: 18px;
    color: #333;
    margin-bottom: 15px;
    border-bottom: 2px solid #f0f0f0;
    padding-bottom: 10px;
`;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
`;

const Th = styled.th`
    text-align: left;
    padding: 12px;
    background-color: #f8f9fa;
    border-bottom: 2px solid #dee2e6;
    color: #495057;
`;

const Td = styled.td`
    padding: 12px;
    border-bottom: 1px solid #dee2e6;
    color: #212529;
`;

const ChartContainer = styled.div`
    display: flex;
    align-items: flex-end;
    height: 300px;
    gap: 20px;
    padding: 20px 10px 60px 10px;
    overflow-x: auto;
    
    &::-webkit-scrollbar {
        height: 8px;
    }
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
    }
    &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 4px;
    }
`;

const BarGroup = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    justify-content: flex-end;
    min-width: 50px;
    position: relative;
`;

const Bar = styled.div`
    width: 40px;
    background-color: #008080;
    height: ${props => props.height}%;
    border-radius: 4px 4px 0 0;
    transition: height 0.3s ease;
    position: relative;
    &:hover::after {
        content: '${props => props.value}';
        position: absolute;
        top: -30px;
        left: 50%;
        transform: translateX(-50%);
        background: #333;
        color: white;
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 12px;
        z-index: 10;
    }
`;

const BarLabel = styled.span`
    margin-top: 10px;
    font-size: 12px;
    color: #555;
    transform: rotate(-45deg);
    transform-origin: left top;
    white-space: nowrap;
    position: absolute;
    bottom: -45px;
    left: 50%;
`;

const ChartHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 10px;
`;

const ToggleContainer = styled.div`
    display: flex;
    background: #f0f0f0;
    border-radius: 8px;
    padding: 4px;
    gap: 4px;
`;

const ToggleButton = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    border: none;
    border-radius: 6px;
    background: ${props => props.active ? 'white' : 'transparent'};
    color: ${props => props.active ? '#008080' : '#666'};
    box-shadow: ${props => props.active ? '0 2px 4px rgba(0,0,0,0.1)' : 'none'};
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s;
    
    &:hover {
        color: #008080;
    }
`;

const PieChartWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 40px;
    padding: 20px;
    flex-wrap: wrap;
`;

const PieChart = styled.div`
    width: 250px;
    height: 250px;
    border-radius: 50%;
    background: conic-gradient(
        ${props => props.segments.map(s => `${s.color} ${s.start}% ${s.end}%`).join(', ')}
    );
    position: relative;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    
    &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 150px;
        height: 150px;
        background: white;
        border-radius: 50%;
    }
`;

const LegendContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const LegendItem = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #333;
`;

const ColorDot = styled.div`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${props => props.color};
`;

const HeatmapGrid = styled.div`
    display: grid;
    grid-template-columns: 40px repeat(24, 1fr);
    gap: 2px;
    overflow-x: auto;
    padding-bottom: 10px;
`;

const HeatmapCell = styled.div`
    width: 100%;
    padding-top: 100%; /* Aspect ratio 1:1 */
    background-color: ${props => props.color};
    position: relative;
    border-radius: 2px;
    
    &:hover::after {
        content: '${props => props.title}';
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        background: #333;
        color: white;
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 10px;
        white-space: nowrap;
        z-index: 10;
        pointer-events: none;
    }
`;

const HeatmapLabel = styled.div`
    font-size: 10px;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 5px;
`;

const HeatmapHeader = styled.div`
    font-size: 10px;
    color: #666;
    text-align: center;
    margin-bottom: 5px;
`;

const FunnelContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 20px;
`;

const FunnelStep = styled.div`
    width: ${props => props.width}%;
    background-color: ${props => props.color};
    padding: 15px;
    color: white;
    text-align: center;
    border-radius: 4px;
    position: relative;
    transition: width 0.5s ease;
    min-width: 200px;
    
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const HorizontalBarContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const HorizontalBarWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

const HorizontalBarLabel = styled.div`
    width: 150px;
    font-size: 14px;
    color: #333;
    text-align: right;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const HorizontalBarTrack = styled.div`
    flex: 1;
    background: #f0f0f0;
    height: 20px;
    border-radius: 4px;
    overflow: hidden;
`;

const HorizontalBarFill = styled.div`
    height: 100%;
    background-color: #008080;
    width: ${props => props.width}%;
    transition: width 0.5s ease;
`;

const HorizontalBarValue = styled.div`
    width: 40px;
    font-size: 14px;
    color: #666;
`;

const SearchContainer = styled.div`
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
`;

const Input = styled.input`
    flex: 1;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
`;

const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    gap: 15px;
    flex-wrap: wrap;
`;

const PageButton = styled.button`
    padding: 8px 16px;
    border: 1px solid #008080;
    background-color: ${props => props.disabled ? '#f5f5f5' : 'white'};
    color: ${props => props.disabled ? '#ccc' : '#008080'};
    border-radius: 4px;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    font-size: 14px;
    transition: all 0.2s;

    &:hover:not(:disabled) {
        background-color: #008080;
        color: white;
    }
`;

const SelectLimit = styled.select`
    padding: 8px 16px;
    border: 1px solid #008080;
    background-color: white;
    color: #008080;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    outline: none;
    transition: all 0.2s;

    &:hover {
        background-color: #008080;
        color: white;
    }

    option {
        background-color: white;
        color: #333;
    }
`;

const RelatorioDeUso = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [congregacoes, setCongregacoes] = useState([]);
    
    // Filtros
    const [filtroCongregacao, setFiltroCongregacao] = useState('');
    const [filtroPerfil, setFiltroPerfil] = useState('');
    const [dataInicio, setDataInicio] = useState('');
    const [dataFim, setDataFim] = useState('');

    // Busca
    const [termoBusca, setTermoBusca] = useState('');
    const [filtroPerfilBusca, setFiltroPerfilBusca] = useState('');
    const [filtroStatusSenha, setFiltroStatusSenha] = useState('');
    const [filtroDataInicioLogin, setFiltroDataInicioLogin] = useState('');
    const [filtroDataFimLogin, setFiltroDataFimLogin] = useState('');
    const [resultadoBusca, setResultadoBusca] = useState([]);
    const [pageBusca, setPageBusca] = useState(1);
    const [limitBusca, setLimitBusca] = useState(10);
    const [totalBusca, setTotalBusca] = useState(0);

    // Paginação
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    
    // Paginação Ativos
    const [pageAtivos, setPageAtivos] = useState(1);
    const [limitAtivos, setLimitAtivos] = useState(10);

    // Modal Usuários Ativos
    const [showModalAtivos, setShowModalAtivos] = useState(false);
    const [usuariosAtivosAgora, setUsuariosAtivosAgora] = useState([]);
    const [loadingAtivos, setLoadingAtivos] = useState(false);

    // Ranking Congregações
    const [rankingType, setRankingType] = useState('cadastrados');
    const [rankingData, setRankingData] = useState([]);

    // Tipo de Gráfico
    const [tipoGrafico, setTipoGrafico] = useState('barras'); // 'barras' | 'pizza'

    useEffect(() => {
        carregarCongregacoes();
        carregarDados();
    }, []);

    useEffect(() => {
        carregarDados();
        setPage(1);
        setPageAtivos(1);
    }, [filtroCongregacao, filtroPerfil, dataInicio, dataFim]);

    useEffect(() => {
        carregarRanking();
    }, [rankingType, filtroCongregacao, filtroPerfil]);

    const carregarCongregacoes = async () => {
        try {
            const res = await CongregacaoService.getCongregacoes();
            setCongregacoes(res || []);
        } catch (error) {
            console.error("Erro ao carregar congregações", error);
        }
    };

    const carregarRanking = async () => {
        try {
            const filtros = {
                congregacao: filtroCongregacao,
                perfil: filtroPerfil
            };
            const res = await RelatoriosService.getRankingCongregacoes(filtros, rankingType);
            setRankingData(res || []);
        } catch (error) {
            console.error("Erro ao carregar ranking", error);
        }
    };

    const carregarDados = async () => {
        setLoading(true);
        try {
            const filtros = {
                congregacao: filtroCongregacao,
                perfil: filtroPerfil,
                dataInicio,
                dataFim
            };
            const res = await RelatoriosService.getDashboardData(filtros);
            setData(res);
            // Inicializa ranking com dados do dashboard se for o tipo padrão, ou carrega separado
            if (rankingType === 'cadastrados' && res.distribuicaoCongregacao) {
                setRankingData(res.distribuicaoCongregacao);
            } else {
                carregarRanking();
            }
        } catch (error) {
            console.error("Erro ao carregar dashboard", error);
        } finally {
            setLoading(false);
        }
    };

    const executarBusca = async (pagina = 1, limite = 10, termo = termoBusca, perfil = filtroPerfilBusca, statusSenha = filtroStatusSenha, dataInicio = filtroDataInicioLogin, dataFim = filtroDataFimLogin) => {
        try {
            const res = await RelatoriosService.buscarStatusUsuario(termo, pagina, limite, perfil, statusSenha, dataInicio, dataFim);
            setResultadoBusca(res.usuarios || []);
            setTotalBusca(res.total || 0);
            setPageBusca(pagina);
            setLimitBusca(limite);
        } catch (error) {
            console.error("Erro na busca", error);
        }
    };

    const handleShowAtivos = async () => {
        setLoadingAtivos(true);
        setShowModalAtivos(true);
        try {
            const filtros = {
                congregacao: filtroCongregacao,
                perfil: filtroPerfil
            };
            const res = await RelatoriosService.getUsuariosAtivosAgora(filtros);
            setUsuariosAtivosAgora(res || []);
        } catch (error) {
            console.error("Erro ao carregar usuários ativos agora", error);
        } finally {
            setLoadingAtivos(false);
        }
    };

    const handleBuscarUsuario = () => {
        executarBusca(1, limitBusca, termoBusca, filtroPerfilBusca, filtroStatusSenha, filtroDataInicioLogin, filtroDataFimLogin);
    };

    const handlePageBuscaChange = (newPage) => {
        const totalPages = Math.ceil(totalBusca / limitBusca);
        if (newPage >= 1 && newPage <= totalPages) {
            executarBusca(newPage, limitBusca, termoBusca, filtroPerfilBusca, filtroStatusSenha, filtroDataInicioLogin, filtroDataFimLogin);
        }
    };

    const handleLimitBuscaChange = (e) => {
        const newLimit = Number(e.target.value);
        setLimitBusca(newLimit);
        executarBusca(1, newLimit, termoBusca, filtroPerfilBusca, filtroStatusSenha, filtroDataInicioLogin, filtroDataFimLogin);
    };

    const handlePageChange = (newPage) => {
        const pendentes = data?.pendentes || [];
        const totalPages = Math.ceil(pendentes.length / limit);
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    const handleLimitChange = (e) => {
        setLimit(Number(e.target.value));
        setPage(1);
    };

    const handlePageAtivosChange = (newPage) => {
        const ativos = data?.ativos || [];
        const totalPages = Math.ceil(ativos.length / limitAtivos);
        if (newPage >= 1 && newPage <= totalPages) {
            setPageAtivos(newPage);
        }
    };

    const handleLimitAtivosChange = (e) => {
        setLimitAtivos(Number(e.target.value));
        setPageAtivos(1);
    };

    // Calcular máximo para o gráfico
    const maxAcessos = data?.acessosDia?.reduce((max, item) => Math.max(max, item.count), 0) || 1;

    // Dados para o gráfico de pizza
    const totalUsuarios = data?.estatisticas?.totalUsuarios || 0;
    const ativos = data?.ativosAgora || 0; // Usuários ativos agora (30min)
    // Ou se preferir "Usuários que já acessaram" vs "Pendentes"
    // O usuário pediu: Total, Ativos, Pendentes.
    // Vamos considerar:
    // 1. Ativos (Online/Recente)
    // 2. Pendentes (Nunca acessaram)
    // 3. Inativos (Restante)
    const pendentesCount = data?.estatisticas?.usuariosPendentes || 0;
    const inativos = Math.max(0, totalUsuarios - ativos - pendentesCount);

    const pieSegments = [
        { label: 'Ativos Agora', value: ativos, color: '#4CAF50' },
        { label: 'Pendentes', value: pendentesCount, color: '#FF9800' },
        { label: 'Offline/Inativos', value: inativos, color: '#9E9E9E' }
    ];

    // Calcular porcentagens para o conic-gradient
    let currentAngle = 0;
    const pieData = pieSegments.map(segment => {
        const percentage = totalUsuarios > 0 ? (segment.value / totalUsuarios) * 100 : 0;
        const start = currentAngle;
        const end = currentAngle + percentage;
        currentAngle = end;
        return { ...segment, start, end, percentage };
    });

    // Dados paginados
    const pendentes = data?.pendentes || [];
    const totalPages = Math.ceil(pendentes.length / limit);
    const startIndex = (page - 1) * limit;
    const paginatedPendentes = pendentes.slice(startIndex, startIndex + limit);

    const listaAtivos = data?.ativos || [];
    const totalPagesAtivos = Math.ceil(listaAtivos.length / limitAtivos);
    const startIndexAtivos = (pageAtivos - 1) * limitAtivos;
    const paginatedAtivos = listaAtivos.slice(startIndexAtivos, startIndexAtivos + limitAtivos);

    // Dados Funil
    const funnelData = [
        { label: 'Usuários Criados', value: totalUsuarios, color: '#2196F3' },
        { label: 'Primeiro Acesso', value: data?.estatisticas?.usuariosComAcesso || 0, color: '#00BCD4' },
        { label: 'Acesso Recorrente (7 dias)', value: data?.estatisticas?.usuariosRecorrentes || 0, color: '#4CAF50' }
    ];
    const maxFunnel = totalUsuarios || 1;

    // Dados Heatmap
    const heatmapGrid = Array(7).fill(null).map(() => Array(24).fill(0));
    data?.mapaCalor?.forEach(item => {
        const dayIndex = item._id.dia - 1; 
        const hourIndex = item._id.hora;
        if (dayIndex >= 0 && dayIndex < 7 && hourIndex >= 0 && hourIndex < 24) {
            heatmapGrid[dayIndex][hourIndex] = item.count;
        }
    });
    const maxHeatmap = data?.mapaCalor?.reduce((max, item) => Math.max(max, item.count), 0) || 1;
    const daysOfWeek = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

    // Dados Congregação
    const maxCongregacao = rankingData.reduce((max, item) => Math.max(max, item.count), 0) || 1;

    return (
        <PageWrapper>
            <Header />
            <MainContentWrapper>
                <Menu />
                <Container>
                    <Titulo>Dashboard de Uso e Monitoramento</Titulo>

                    <FiltrosContainer>
                        <FiltroGroup>
                            <Label>Congregação:</Label>
                            <SelectFilter value={filtroCongregacao} onChange={e => setFiltroCongregacao(e.target.value)}>
                                <option value="">Todas as Congregações</option>
                                {congregacoes.map(c => (
                                    <option key={c._id} value={c._id}>{c.nome}</option>
                                ))}
                            </SelectFilter>
                        </FiltroGroup>

                        <FiltroGroup>
                            <Label>Perfil:</Label>
                            <SelectFilter value={filtroPerfil} onChange={e => setFiltroPerfil(e.target.value)}>
                                <option value="">Todos os Perfis</option>
                                <option value="publicador">Publicador</option>
                                <option value="admin">Admin</option>
                                <option value="coordenador-geral">Coord. Geral</option>
                                <option value="coordenador-regional">Coord. Regional</option>
                                <option value="coordenador-ponto">Coord. Ponto</option>
                            </SelectFilter>
                        </FiltroGroup>

                        <FiltroGroup>
                            <Label>Data Início:</Label>
                            <InputDateFilter
                                type="date"
                                value={dataInicio}
                                onChange={e => setDataInicio(e.target.value)}
                                placeholder="Data Início"
                            />
                        </FiltroGroup>

                        <FiltroGroup>
                            <Label>Data Fim:</Label>
                            <InputDateFilter
                                type="date"
                                value={dataFim}
                                onChange={e => setDataFim(e.target.value)}
                                placeholder="Data Fim"
                            />
                        </FiltroGroup>
                    </FiltrosContainer>

                    {loading && <div style={{ width: '100%', textAlign: 'center', padding: '20px', color: '#666' }}>Carregando...</div>}

            {data && (
                <>
                    <StatsGrid>
                        <StatCard color="#2196F3">
                            <FaUsers size={24} color="#2196F3" />
                            <StatValue>{data.estatisticas.totalUsuarios}</StatValue>
                            <StatLabel>Total de Usuários</StatLabel>
                        </StatCard>
                        <StatCard color="#4CAF50" onClick={handleShowAtivos} title="Clique para ver detalhes">
                            <FaUserClock size={24} color="#4CAF50" />
                            <StatValue>{data.ativosAgora}</StatValue>
                            <StatLabel>Usuários Ativos (30min)</StatLabel>
                        </StatCard>
                        <StatCard color="#FF9800">
                            <FaExclamationTriangle size={24} color="#FF9800" />
                            <StatValue>{data.estatisticas.usuariosPendentes}</StatValue>
                            <StatLabel>Senhas Temporárias</StatLabel>
                        </StatCard>
                        <StatCard color="#9C27B0">
                            <FaChartLine size={24} color="#9C27B0" />
                            <StatValue>{data.estatisticas.usuariosComAcesso}</StatValue>
                            <StatLabel>Já Acessaram</StatLabel>
                        </StatCard>
                    </StatsGrid>

                    <Section>
                        <SectionTitle>Usuários Pendentes (Senha Temporária e Sem Login)</SectionTitle>
                        <div style={{ overflowX: 'auto' }}>
                            <Table>
                                <thead>
                                    <tr>
                                        <Th>Nome</Th>
                                        <Th>Email</Th>
                                        <Th>Congregação</Th>
                                        <Th>Perfil</Th>
                                        <Th>Gerado em</Th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paginatedPendentes.map(u => (
                                        <tr key={u._id}>
                                            <Td>{u.nome}</Td>
                                            <Td>{u.email}</Td>
                                            <Td>{u.congregacao?.nome || '-'}</Td>
                                            <Td>{u.perfil.join(', ')}</Td>
                                            <Td>{u.dataGeracaoSenha ? new Date(u.dataGeracaoSenha).toLocaleDateString() : '-'}</Td>
                                        </tr>
                                    ))}
                                    {paginatedPendentes.length === 0 && <tr><Td colSpan="5">Nenhum usuário pendente.</Td></tr>}
                                </tbody>
                            </Table>
                        </div>
                        
                        {pendentes.length > 0 && (
                            <PaginationContainer>
                                <PageButton 
                                    onClick={() => handlePageChange(page - 1)} 
                                    disabled={page === 1}
                                >
                                    Anterior
                                </PageButton>
                                <span style={{ fontSize: '14px', color: '#666' }}>
                                    Página {page} de {totalPages}
                                </span>
                                <PageButton 
                                    onClick={() => handlePageChange(page + 1)} 
                                    disabled={page === totalPages}
                                >
                                    Próxima
                                </PageButton>

                                <SelectLimit value={limit} onChange={handleLimitChange}>
                                    <option value={10}>10 por página</option>
                                    <option value={15}>15 por página</option>
                                    <option value={25}>25 por página</option>
                                    <option value={999999}>Ver tudo</option>
                                </SelectLimit>
                            </PaginationContainer>
                        )}
                    </Section>

                    <Section>
                        <SectionTitle>Usuários Ativos (Não Pendentes)</SectionTitle>
                        <div style={{ overflowX: 'auto' }}>
                            <Table>
                                <thead>
                                    <tr>
                                        <Th>Nome</Th>
                                        <Th>Email</Th>
                                        <Th>Congregação</Th>
                                        <Th>Perfil</Th>
                                        <Th>Último Login</Th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paginatedAtivos.map(u => (
                                        <tr key={u._id}>
                                            <Td>{u.nome}</Td>
                                            <Td>{u.email}</Td>
                                            <Td>{u.congregacao?.nome || '-'}</Td>
                                            <Td>{u.perfil.join(', ')}</Td>
                                            <Td>{u.ultimoLogin ? new Date(u.ultimoLogin).toLocaleString() : '-'}</Td>
                                        </tr>
                                    ))}
                                    {paginatedAtivos.length === 0 && <tr><Td colSpan="5">Nenhum usuário ativo encontrado.</Td></tr>}
                                </tbody>
                            </Table>
                        </div>
                        
                        {listaAtivos.length > 0 && (
                            <PaginationContainer>
                                <PageButton 
                                    onClick={() => handlePageAtivosChange(pageAtivos - 1)} 
                                    disabled={pageAtivos === 1}
                                >
                                    Anterior
                                </PageButton>
                                <span style={{ fontSize: '14px', color: '#666' }}>
                                    Página {pageAtivos} de {totalPagesAtivos}
                                </span>
                                <PageButton 
                                    onClick={() => handlePageAtivosChange(pageAtivos + 1)} 
                                    disabled={pageAtivos === totalPagesAtivos}
                                >
                                    Próxima
                                </PageButton>

                                <SelectLimit value={limitAtivos} onChange={handleLimitAtivosChange}>
                                    <option value={10}>10 por página</option>
                                    <option value={15}>15 por página</option>
                                    <option value={25}>25 por página</option>
                                    <option value={999999}>Ver tudo</option>
                                </SelectLimit>
                            </PaginationContainer>
                        )}
                    </Section>

                    <Section>
                        <SectionTitle>Buscar Situação do Usuário</SectionTitle>
                        <SearchContainer>
                            <Input 
                                type="text" 
                                placeholder="Buscar por nome ou email..." 
                                value={termoBusca}
                                onChange={e => setTermoBusca(e.target.value)}
                            />
                            <Button onClick={handleBuscarUsuario}><FaSearch /> Buscar</Button>
                            <Button onClick={() => { 
                                setTermoBusca(''); 
                                setFiltroPerfilBusca(''); 
                                setFiltroStatusSenha('');
                                setFiltroDataInicioLogin('');
                                setFiltroDataFimLogin('');
                                executarBusca(1, limitBusca, '', '', '', '', ''); 
                            }} style={{ marginLeft: '10px', backgroundColor: '#666' }}>Ver Todos</Button>
                        </SearchContainer>

                        {/* Filtros Avançados aparecem apenas quando não há termo de busca (modo Ver Todos) e há resultados */}
                        {!termoBusca && resultadoBusca.length > 0 && (
                            <div style={{ marginBottom: '20px', display: 'flex', flexWrap: 'wrap', gap: '20px', padding: '15px', background: '#f9f9f9', borderRadius: '8px', border: '1px solid #eee' }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Label style={{ fontSize: '12px', marginBottom: '4px' }}>Perfil:</Label>
                                    <SelectFilter 
                                        value={filtroPerfilBusca} 
                                        onChange={e => {
                                            setFiltroPerfilBusca(e.target.value);
                                            executarBusca(1, limitBusca, '', e.target.value, filtroStatusSenha, filtroDataInicioLogin, filtroDataFimLogin);
                                        }} 
                                        style={{ minWidth: '150px' }}
                                    >
                                        <option value="">Todos os Perfis</option>
                                        <option value="publicador">Publicador</option>
                                        <option value="admin">Admin</option>
                                        <option value="coordenador-geral">Coord. Geral</option>
                                        <option value="coordenador-regional">Coord. Regional</option>
                                        <option value="coordenador-ponto">Coord. Ponto</option>
                                    </SelectFilter>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Label style={{ fontSize: '12px', marginBottom: '4px' }}>Status Senha:</Label>
                                    <SelectFilter 
                                        value={filtroStatusSenha} 
                                        onChange={e => {
                                            setFiltroStatusSenha(e.target.value);
                                            executarBusca(1, limitBusca, '', filtroPerfilBusca, e.target.value, filtroDataInicioLogin, filtroDataFimLogin);
                                        }} 
                                        style={{ minWidth: '150px' }}
                                    >
                                        <option value="">Todos</option>
                                        <option value="temporaria">Temporária</option>
                                        <option value="definitiva">Definitiva</option>
                                    </SelectFilter>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Label style={{ fontSize: '12px', marginBottom: '4px' }}>Login De:</Label>
                                    <InputDateFilter
                                        type="date"
                                        value={filtroDataInicioLogin}
                                        onChange={e => {
                                            setFiltroDataInicioLogin(e.target.value);
                                            executarBusca(1, limitBusca, '', filtroPerfilBusca, filtroStatusSenha, e.target.value, filtroDataFimLogin);
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Label style={{ fontSize: '12px', marginBottom: '4px' }}>Login Até:</Label>
                                    <InputDateFilter
                                        type="date"
                                        value={filtroDataFimLogin}
                                        onChange={e => {
                                            setFiltroDataFimLogin(e.target.value);
                                            executarBusca(1, limitBusca, '', filtroPerfilBusca, filtroStatusSenha, filtroDataInicioLogin, e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                        )}

                        {resultadoBusca.length > 0 ? (
                            <>
                                <Table>
                                    <thead>
                                        <tr>
                                            <Th>Nome</Th>
                                            <Th>Email</Th>
                                            <Th>Último Login</Th>
                                            <Th>Status Senha</Th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {resultadoBusca.map(u => (
                                            <tr key={u._id}>
                                                <Td>{u.nome}</Td>
                                                <Td>{u.email}</Td>
                                                <Td>{u.ultimoLogin ? new Date(u.ultimoLogin).toLocaleString() : 'Nunca acessou'}</Td>
                                                <Td>
                                                    {u.isSenhaTemporaria 
                                                        ? <span style={{color: 'orange', fontWeight: 'bold'}}>Temporária</span> 
                                                        : <span style={{color: 'green', fontWeight: 'bold'}}>Definitiva</span>
                                                    }
                                                </Td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>

                                <PaginationContainer>
                                    <PageButton 
                                        onClick={() => handlePageBuscaChange(pageBusca - 1)} 
                                        disabled={pageBusca === 1}
                                    >
                                        Anterior
                                    </PageButton>
                                    <span style={{ fontSize: '14px', color: '#666' }}>
                                        Página {pageBusca} de {Math.ceil(totalBusca / limitBusca)}
                                    </span>
                                    <PageButton 
                                        onClick={() => handlePageBuscaChange(pageBusca + 1)} 
                                        disabled={pageBusca === Math.ceil(totalBusca / limitBusca)}
                                    >
                                        Próxima
                                    </PageButton>

                                    <SelectLimit value={limitBusca} onChange={handleLimitBuscaChange}>
                                        <option value={10}>10 por página</option>
                                        <option value={15}>15 por página</option>
                                        <option value={25}>25 por página</option>
                                        <option value={999999}>Ver tudo</option>
                                    </SelectLimit>
                                </PaginationContainer>
                            </>
                        ) : (
                            <p style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                                {termoBusca ? 'Nenhum usuário encontrado.' : 'Utilize a busca ou clique em "Ver Todos" para listar os usuários.'}
                            </p>
                        )}
                    </Section>
                </>
            )}
            {showModalAtivos && (
                <ModalOverlay onClick={() => setShowModalAtivos(false)}>
                    <ModalContent onClick={e => e.stopPropagation()}>
                        <CloseButton onClick={() => setShowModalAtivos(false)}><FaTimes /></CloseButton>
                        <ModalTitle>Usuários Ativos Agora (30min)</ModalTitle>
                        
                        {loadingAtivos ? (
                            <p>Carregando...</p>
                        ) : (
                            <UserList>
                                {usuariosAtivosAgora.map(u => (
                                    <UserItem key={u._id}>
                                        <div>
                                            <strong>{u.nome}</strong>
                                            <div style={{ fontSize: '12px', color: '#666' }}>{u.email}</div>
                                            <div style={{ fontSize: '12px', color: '#888' }}>{u.congregacao?.nome || '-'}</div>
                                        </div>
                                        <div style={{ fontSize: '12px', color: '#008080' }}>
                                            {u.ultimoLogin ? new Date(u.ultimoLogin).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}) : ''}
                                        </div>
                                    </UserItem>
                                ))}
                                {usuariosAtivosAgora.length === 0 && <p>Nenhum usuário ativo no momento.</p>}
                            </UserList>
                        )}
                    </ModalContent>
                </ModalOverlay>
            )}
                </Container>
            </MainContentWrapper>
            <Rodape />
        </PageWrapper>
    );
};

export default RelatorioDeUso;
